export enum ApiRoutes {
  AUTH_EXTERNAL = '/accounts/signup_external',
  AUTH_EXTERNAL_FACEBOOK_BIND_EMAIL = '/accounts/signup_external/facebook-bind-email',
  AUTH_TERMSANDCONDITIONS = '/application/content/',
  AUTH_INTERNAL = '/accounts/signup',
  ACC_EXISTS = '/accounts/exists',
  RESOLVE_EXTERNAL = '/accounts/signup_external/resolve_user',
  LOGIN = '/accounts/login',
  PROFILE = '/me/profile',
  ACCOUNT = '/me/account',
  EXISTS = '/accounts/exists',
  RESETPW = '/accounts/reset_password',
  RESENDCONFIRM = '/accounts/resend_confirmation',
  CHANGEPW = '/me/change_password',
  GIFTCARD = '/me/giftcard',
  REFRESHTOKEN = '/accounts/refresh_token',
  EMAIL_UNSUBSCRIBE = '/accounts/notifications/email',

  GUEST_CHECKOUT = '/meals/orders/guestusercheckout',
  GUEST_CANCEL_ORDER = '/meals/orders/guestuser/{id}/{guestUserGuid}',
  GET_ORDER_STATUS_GUEST = '/meals/orders/{id}/guestuser/{orderGuid}/status',
  GET_ORDER_BY_ID_GUEST = '/meals/orders/{id}/guestuser/{orderGuid}',
  VIEW_RECEIPT_GUEST = '/meals/orders/{id}/guestuser/{orderGuid}/receipt',

  PAYMENT_METHODS = '/me/payment_methods',
  CHECKGIFTCARDBALANCE = '/payment/giftcard',
  PAYMENT_ACTIVE_PROVIDER = '/payment/active-provider',
  APPLEPAY_MERCHANT_SESSION = '/payment/apple/request-session',
  TRANSFERGIFTCARDBALANCE = '/me/giftcard/load_using_another_card',
  RELOAD_CARD = '/me/giftcard/load',
  RELOAD_CARD_With_Paypal = '/me/giftcard/load_using_paypal',
  AUTO_RELOAD = '/me/payment_methods/auto_reload',
  GET_WALLET = '/me/wallet',
  SET_AS_DEFAULT = '/me/payment_methods/default',
  CMS_FEATURES = '/cms/features/',
  CMS_BENEFITS = '/cms/benefits/',
  GENERIC_MENU = '/menu',
  NOTIFICATIONS_PUSH = '/me/notifications/push',
  NOTIFICATIONS_EMAIL = '/me/notifications/email',
  GET_RECENT_ORDERS = '/me/meals/orders/recent',
  GET_RECENT_ORDERS_INFO = '/me/meals/orders/recent-info',
  GET_MOST_RECENT_AVAILABLE = '/me/meals/orders/recent-available',
  GET_PENDING_ORDERS = '/me/meals/orders/pending',
  GET_INTERNAL_ORDER_LOCATION_ID = '/internal/orders/location/',
  GET_ORDERS_ID = '/me/meals/order/',
  GET_FAVORITES = '/me/favorites/meals',
  ADD_FAVORITES = '/me/favorites/meals',
  GET_FAVORITES_ID = '/me/meals/favorites',
  DELETE_FAVORITES = '/me/favorites/meals/',
  GET_ACTIVE_REWARDS = '/me/rewards/active',
  REVERSE_GEOCODE = '/locations/reverse_geocode',
  LOCATIONS = '/locations/',
  UNIT_LOCATION = '/locations',
  GEO_COORDINATES_BY_IP = '/client/geo-coordinates',
  GEO_COORDINATES = '/locations/geo-coordinates',
  LOCATION_FAVORITES = '/me/favorites/locations',
  DISTANCE_MATRIX = '/locations/distance_matrix',
  GET_REWARDS = '/rewards/recipe/item',
  MENU_ITEM_POINTS = '/rewards/menu-item-points',
  AMENITIES = '/locations/amenities',
  ADDRESS_VERIFICATION = '/locations/validate-address',
  DELIVERY_QUOTE = '/orders/delivery/request-quote',
  SORT_FAVORITES = '/me/favorites/meals/sort',
  MENU_CATEGORIES = '/menu/categories',
  MENU_CATEGORIES_RECIPES = '/recipes',
  GET_CHILD_RECIPE = '/locations/{locationId}/menu/child-recipes/{childRecipeId}',
  CHILD_RECIPE = '/menu/child-recipes',
  ACCOUNT_HISTORY = '/me/history',
  ACCOUNT_MESSAGES = '/me/messages',
  MESSAGE_DELETE = '/me/messages/mark_deleted',
  MESSAGE_READ = '/me/messages/mark_read',
  ORDER_STATUS = '/me/meals/orders/',
  SAVE_FAVORITE_ORDER = '/me/orders/{id}/favorite',
  SAVE_FAVORITE = '/me/orders/',
  CANCEL_ORDER = '/me/meals/orders/',
  CHANGE_PICKUPTIME = '/me/meals/orders/',
  ORDER_STATUS_CONTENTS = '/application/order_status_contents',
  CHANGE_PICKUP_OPTIONS = '/locations/{locationId}/order-pickup-options',
  GET_START_ORDER_IMAGES = '/application/start_order_images',
  VIEW_RECEIPT = '/me/meals/orders/',
  ORDER_PICKUP_OPTIONS = '/locations/{locationId}/order-pickup-options',
  GET_ORDER_BY_ID = '/me/meals/order/',
  SUBMIT_ORDER = '/me/meals/orders/submit',
  CHECKIN_OPTIONS = '/check-in-options',
  REWARD_SUMMARY = '/me/summary',
  GET_OFFERS = '/me/offers',
  VALIDATE_CUSTOMERS = '/accounts/validate_customerInfo',
  VALIDATE_SIGNUPCUSTOMERS = '/accounts/signup_external/validate_request',
  ORDER_CONFIG = '/application/order_config',
  CHILD_RECIPE_ONLY = '/child-recipes',
  FEEDBACK = '/me/order/feedback',
  FAQ = '/application/faqs',
  EMERGENCY_BANNER = '/application/emergency-banner',
  SUBMIT_FEEDBACK = '/application/feedbacks',
  SETTINGSBYID = '/application/settings',
  CONTENTPAGE = '/application/contentpages',
  GALLERY = '/application/galleries/slugs',
  METADATASLUG = '/application/metadata/slugs',
  METADATA = '/application/metadata',
  SIGNUP = '/application/signup',
  DOTCOMSIGNUP = '/accounts/wbdotcomsignup',
  SHAREDFAVORITE = '/meals/favorites/shared',
  GET_LOCATION_BY_UNIT = '/internal/location',
  GROUP_DINING_CONTACT = '/application/group-dining-contact-us',
  SUBMIT_GROUP_DINING = '/application/group-dining',
  CLAIM_VISIT = '/me/orders/claim-visit',
  APPLY_FOR_SUPPORT = '/sponsorship/check-eligibility',
  MFA_REQUEST_CODE = '/accounts/login/mfa/send',
  MFA_CONFIRM_CODE = '/accounts/login/mfa/confirm',
  AUTH0_IDENTIFY = '/accounts/sessions/identify',
  AUTH0_SIGNUP_CHECK = '/accounts/signup/check',
  AUTH0_OTP_INITIATE = '/accounts/sessions/otp/initiate',
  AUTH0_OTP_VERIFY = '/accounts/sessions/otp/verify',
  AUTH0_SIGNUP_COMPLETE = '/accounts/signup/complete',
  // AUTH0_SIGNUP_LINK_ACCOUNT = '/accounts/signup/link-account',
  AUTH0_SIGNUP_LINK_PHONE = '/accounts/signup/link-phone',
  AUTH0_MAGICLINK_CALLBACK = '/accounts/sessions/magiclink/callback',
  AUTH0_MIGRATE_SESSION = '/accounts/sessions/migrate',
  AUTH0_SOCIAL_LINK_CHALLENGE_COMPLETE = '/accounts/signup/social-link-challenge-complete',
  // Franchise application
  FRANCHISE = '/application/locations/franchise/apply',
  UPLOADFILE = '/application/files',
  // Contact us categories
  CONTACT_CATEGORIES = '/application/feedback-values',
  //Delivery Address
  DELIVERY_ADDRESSES = '/me/delivery/addresses',
  GIFTCARD_CONFIG = '/gift-cards/configuration',
  VIRTUAL_GIFT_CARD = '/gift-cards',
  LOYALTY_CONFIG = '/rewards/loyalty-config',
  REDEEM_REWARD = '/me/menu-item-points/redeem',
  GET_POINTS = '/me/menu-item-points',
  GET_REDEEMED = '/me/menu-item-points/redeemed',
  CONVERT_REWARDS_TO_POINTS = '/me/menu-item-points/refund',
  CUSTOMIZATION_GROUP_LOOKUP = '/menu/customization-groups',
  MODIFIER_GROUP_LOOKUP = '/menu/modifier-groups',
  MODIFIER_LOOKUP = '/menu/modifiers',
  SPECIAL_INSTRUCTION_LOOKUP = '/menu/special-instructions',
  BRAZE_USERS = '/me/braze/users',
  EXCLUSIVE_REWARDS = '/rewards/exclusive',
  REDEEM_EXCLUSIVE_REWARD = "/rewards/exclusive/order",
  APPLE_MAPS_TOKEN = '/application/apple-maps/access-token',
  FEEDBACK_OPTIONS = '/application/feedback-options',
  TNC_VERSION_LATEST = '/me/tncversion/latest',
  TNC_VERSION = '/me/tncversion',
  REWARDS_OFFERS = '/rewards/offers'
}
